import React, {useState, useEffect} from 'react';
import {Box, Button, TextField, Typography} from '@mui/material';
import {useNavigate} from 'react-router-dom';
import {getIdMeBaseApiUrl} from "../../utils/UrlConstants";
import NavBar from "../pages/NavBar/NavBar";
import { checkUserAuthentication, handleUnauthenticatedUser } from "../../utils/authUtils";
import { useIdentityAppService } from '../../services/IdentityServices';

const AdminLogin: React.FC = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        if (!checkUserAuthentication()) {
            handleUnauthenticatedUser();
            return;
        }
    }, []);

    const handleLogin = () => {
        const identityAppService = useIdentityAppService();
        identityAppService.loginAdmin(username, password)
            .then(response => {
                if (response.data === 'Login successful') {
                    // Redirect to admin dashboard or home page
                    navigate('/admin-dashboard');
                } else {
                    setErrorMessage('Invalid username or password');
                }
            })
            .catch(error => {
                setErrorMessage('Error occurred during login');
                console.error(error);
            });
    };

    return (
        <React.Fragment>
            <NavBar/>
            <Box sx={{width: '100%', maxWidth: 360, margin: '0 auto', textAlign: 'center'}}>
                <Typography variant="h4" gutterBottom>
                    Admin Login
                </Typography>
                <TextField
                    label="Username"
                    variant="outlined"
                    fullWidth
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    margin="normal"
                />
                <TextField
                    label="Password"
                    type="password"
                    variant="outlined"
                    fullWidth
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    margin="normal"
                />
                {errorMessage && <Typography color="error">{errorMessage}</Typography>}
                <Button variant="contained" color="primary" onClick={handleLogin} sx={{mt: 2}}>
                    Sign In
                </Button>
            </Box>
        </React.Fragment>
    );
};

export default AdminLogin;
